import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@rocketlane/ui';
import { forwardRef } from 'react';
const LINK_BUTTON_CLASS = 'cp-h-auto cp-p-0 cp-text-[length:inherit]';
export const LinkButton = /*#__PURE__*/ forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx(Button, {
        ref: ref,
        variant: "link",
        size: "medium",
        type: "button",
        className: [
            LINK_BUTTON_CLASS,
            className
        ].filter(Boolean).join(' '),
        ...props
    }));
LinkButton.displayName = 'LinkButton';
